import { useEffect } from 'react'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { SignedIn, SignedOut } from '@clerk/clerk-react'
import { AuthIntermediator } from '@/components/AuthIntermediator'
import Loading from '@/components/Loading'

// Redirects signed-out users to /login, preserving the current path for
// post-auth redirect when the destination is a shardlibrary route.
const RedirectToLogin = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const path = window.location.pathname
    const redirectParam = path.startsWith('/shardlibrary')
      ? `?redirect_url=${encodeURIComponent(path)}`
      : ''
    navigate({ to: `/login${redirectParam}`, replace: true })
  }, [navigate])

  return <Loading />
}

const AuthLayout = () => {
  return (
    <>
      <SignedIn>
        <AuthIntermediator>
          <Outlet />
        </AuthIntermediator>
      </SignedIn>
      <SignedOut>
        <RedirectToLogin />
      </SignedOut>
    </>
  )
}

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
})
